import { useAuth, useFeatureEntitlements } from '@frontegg/react';
import { Button } from 'src/modules/ambient_solo/components/baseComponents';
import { analytics } from 'src/services';

export const CelloWidgetComponent = () => {
  const { isEntitled } = useFeatureEntitlements('referral-program');
  const { user } = useAuth();

  if (!isEntitled) {
    return (
      <div className="page-wrapper cello-widget-side-menu">
        <div className="min-h-dvh flex flex-col justify-center items-center">
          <div className=" w-full max-w-2xl">
            <h1>This feature is not available in your account.</h1>
          </div>
        </div>
      </div>
    );
  }
  const handleOnClick = () => {
    // eslint-disable-next-line no-undef
    analytics.track('Clicked Get Referral Link', {
      email: user?.email,
    });
  };

  return (
    <div className="page-wrapper cello-widget-side-menu">
      <div className="min-h-dvh flex flex-col justify-center items-center">
        <div className=" w-full max-w-2xl">
          <h2 className="text-xl font-bold mb-4">Eligibility</h2>
          <ol className="list-decimal list-inside mb-8 mx-4">
            <li className="mb-2 list-outside">
              Referred users must be qualified clinicians currently working in
              the healthcare industry.
            </li>
            <li className="list-outside">
              New users referred to our service must not have an existing
              account or have been previously contacted by Insight Health AI,
              Inc. prior to the referral.
            </li>
          </ol>
          <div className="cello-referral flex justify-center">
            <Button
              type="button"
              onClick={handleOnClick}
              className={'celloClass relative'}
            >
              {' '}
              Get referral link
            </Button>
          </div>
        </div>
        <div className="w-full max-w-2xl">
          <h2 className="text-xl font-bold mt-6 mb-4">Referral Rewards</h2>
          <h3 className="text-xl font-semibold mb-2">Rewards for Referrers:</h3>
          <ul className="list-disc list-inside mb-6 mx-4">
            <li className="mb-2 list-outside">
              <span className="font-bold">Initial Signup Reward:</span>{' '}
              Referrers will earn a $10 reward for each new user who signs up
              for an account through their unique referral link. New users get
              access to Aura AI Scribe product.
            </li>
            <li className="mb-2 list-outside">
              <span className="font-bold">First Purchase Reward:</span>{' '}
              Referrers will earn a $250 reward when the referred user makes
              their first purchase.
            </li>
            <li className="list-outside">
              <span className="font-bold">Revenue Sharing:</span> Referrers will
              receive 50% of the revenue generated from the purchases made by
              their referrals within the first year, up to a maximum of $1,000
              per referral. This cap includes all types of rewards (Initial
              Signup, First Purchase, and Revenue Sharing) accumulated per
              referral.
            </li>
          </ul>

          <a
            href="https://www.insighthealth.ai/referral-reward-program-terms-of-service"
            target="blank_"
            className="text-blue-500 underline"
          >
            Terms & Conditions
          </a>
        </div>
      </div>
    </div>
  );
};
